import React from "react";
import SurveyHeader from "./Survey/SurveyHeader";
import SurveyQuestion from "./Survey/SurveyQuestion";
import SurveyScoring from "./Survey/SurveyScoring";

const SurveyComponent = ({component, path}) => {
    const {styles: sourceStyles, properties: {showScoring}, children = []} = component;
    const styles = sourceStyles && sourceStyles.length ? {
        header: sourceStyles[0] || {},
        body: sourceStyles[1] || {},
        footer: sourceStyles[2] || {}
    } : {
        header: {},
        body: {},
        footer: {}
    };
    return (
        <div>
            <SurveyHeader
                title={'Survey Header'}
                path={`${path}.children.0`}
                surveyHeader={children[0]}
                styles={styles.header}
            />
            <SurveyQuestion
                path={`${path}.children.1`}
                surveyQuestion={children[1]}
                styles={styles.body}
            />
            {showScoring && (
                <SurveyScoring
                    path={`${path}.children.2`}
                    surveyScoring={children[2]}
                    styles={styles.footer}
                />
            )}
        </div>
    )
};

export default SurveyComponent;